import React from 'react';
import { Link } from 'react-router-dom';
import { UserCog, CloudCog, Cog, Building2 } from 'lucide-react';

const icons = { UserCog, CloudCog, Cog, Building2 };
const skills = {
  1: ['Active Directory', 'Microsoft 365', 'Linux & Windows', 'Helpdesk'],
  2: ['AWS', 'Azure', 'Google Cloud', 'Terraform'],
  3: ['CI/CD', 'Kubernetes', 'Docker', 'GitOps'],
  4: ['Enterprise design', 'Roadmaps', 'Security', 'Integration'],
};

const glow = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty('--mx', `${((e.clientX - r.left) / r.width) * 100}%`);
  e.currentTarget.style.setProperty('--my', `${((e.clientY - r.top) / r.height) * 100}%`);
};

// Concentric dashed rings turning at different speeds, red dots riding them, role icon in the middle.
const Orbit = ({ Icon, size }) => (
  <div className="orbit" style={{ '--s': size }} aria-hidden>
    <span className="orbit-ring r1"><i /></span>
    <span className="orbit-ring r2"><i /></span>
    <span className="orbit-ring r3"><i /></span>
    <span className="orbit-core"><Icon strokeWidth={1.3} /></span>
  </div>
);

// variant "wide": stacked home cards. variant "tile": 4-up grid on the services page.
const StaffCard = ({ role, index, variant = 'tile', className = '', style }) => {
  const Icon = icons[role.icon];
  const n = String(index + 1).padStart(2, '0');
  const wide = variant === 'wide';
  return (
    <article onMouseMove={glow} style={style} className={`staff ${wide ? 'staff-wide' : 'staff-tile'} ${className}`}>
      <div className={wide ? 'grid md:grid-cols-[1fr_17rem] gap-10 items-center' : 'flex flex-col h-full'}>
        <div className={wide ? '' : 'order-2 flex-1 flex flex-col'}>
          <p className="font-mono-label text-[var(--muted)] flex items-center gap-3 whitespace-nowrap"><span className="text-[var(--red)]">Role {n}</span><span className="w-8 h-px bg-[var(--line-strong)]" /><span className="flex items-center gap-2"><span className="pulse-dot" />Available</span></p>
          <h3 className={`font-display mt-5 ${wide ? 'text-4xl md:text-6xl leading-[0.98]' : 'text-3xl leading-[1.05]'}`}>{role.title}</h3>
          <p className={`mt-4 text-[var(--muted)] leading-relaxed ${wide ? 'text-lg max-w-xl' : 'text-sm'}`}>{role.description}</p>
          <ul className="mt-6 flex flex-wrap gap-2">
            {skills[role.id].map((s) => <li key={s} className="px-3 py-1.5 rounded-full border border-[var(--line-strong)] text-xs bg-[var(--glass)]">{s}</li>)}
          </ul>
          <div className={`flex flex-wrap items-center gap-x-6 gap-y-4 ${wide ? 'mt-8' : 'mt-auto pt-7'}`}>
            <Link to="/contact" className="btn btn-ghost !py-2.5 !px-5 text-sm whitespace-nowrap">{wide ? 'Request this role' : 'Request'}</Link>
            {wide && <p className="font-mono-label text-[var(--muted)]">Contract · Long-term · Project</p>}
          </div>
        </div>
        <div className={`grid place-items-center ${wide ? 'hidden md:grid' : 'order-1 mb-6'}`}>
          <Orbit Icon={Icon} size={wide ? '15rem' : '8.5rem'} />
        </div>
      </div>
    </article>
  );
};

export default StaffCard;
